import { render, staticRenderFns } from "./BankLayout.vue?vue&type=template&id=07cc9285&scoped=true&"
import script from "./BankLayout.vue?vue&type=script&lang=js&"
export * from "./BankLayout.vue?vue&type=script&lang=js&"
import style0 from "./BankLayout.vue?vue&type=style&index=0&id=07cc9285&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc9285",
  null
  
)

component.options.__file = "BankLayout.vue"
export default component.exports